module.exports = __webpack_public_path__ + "static/lukasz-gawronski-medinvest-new-5ed9ff5301766f7697234beaf5fcba54.jpg";